import { register } from '@shopify/theme-sections';
import Flickity from 'flickity';
import 'flickity-imagesloaded';

export default register('collection-list', {
  onLoad() {
    this.collectionList = document.querySelector(
      '#collection-list__slider--' + this.id
    );
    if (this.collectionList) {
      this.collectionListSlider = new Flickity(this.collectionList, {
        contain: true,
        prevNextButtons: false,
        pageDots: false,
        imagesLoaded: true,
        watchCSS: true,
      });
    }
  },
});
